var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 11C1.90625 11 1.61188 10.8775 1.36688 10.6325C1.12188 10.3875 0.999584 10.0933 1 9.75V7.875H2.25V9.75H9.75V7.875H11V9.75C11 10.0938 10.8775 10.3881 10.6325 10.6331C10.3875 10.8781 10.0933 11.0004 9.75 11H2.25ZM6 8.5L2.875 5.375L3.75 4.46875L5.375 6.09375V1H6.625V6.09375L8.25 4.46875L9.125 5.375L6 8.5Z",
    fill: "#007BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.e722e138f9ef8292c5c73c8643809389.svg";
export { ForwardRef as ReactComponent };